import { StateCreator } from "zustand";
import { FetchState } from "../../../domain/models/fetch-state";
import { AxiosHttpClient } from "../../../infra/http/axios-http-client";
import { getDataKeyFromLocalStorage } from "../../../common/utils/AuthToken";
import { AUTH_HEADER, SECURE_AUTH_TOKEN_KEY, SECURE_BASE_URL_KEY } from "../../../base";
import Endpoints from "../../../domain/endpoints";
import { AddSmartTourProgram } from "../../../domain/useages/monthly-tour-program/addSmartTourProgram";
import { RemoteAddSmartTourProgram } from "../../../data/usecases/monthly-tour-program/remote-add-smart-tour-program";

export interface AddSmartTourProgramInterface {
  AddSmartTourProgramState: FetchState;
  addSmartTourProgram: Function;
}

const initialStates = {
 AddSmartTourProgramState: FetchState.DEFAULT,
};

const axiosHttpClient = AxiosHttpClient.getInstance();


export const useAddSmartTourProgramSlice: StateCreator<
  AddSmartTourProgramInterface
> = (set) => ({
  ...initialStates,
    addSmartTourProgram: async (payload: AddSmartTourProgram.Params) => {
  
    const token = getDataKeyFromLocalStorage(SECURE_AUTH_TOKEN_KEY) ?? "";
    const BASE_URL = getDataKeyFromLocalStorage(SECURE_BASE_URL_KEY);

    axiosHttpClient.setAuthHeaders({
      [AUTH_HEADER]: token.toString(),
    });

    const remoteAddSmartTourProgram = new RemoteAddSmartTourProgram(
      `${BASE_URL}${Endpoints.ADD_SMART_TOUR_PROGRAM}`,
      axiosHttpClient
    );

    set(() => ({ AddSmartTourProgramState: FetchState.LOADING }));
    let result = await remoteAddSmartTourProgram.add(payload);
    return result;
  },
});
